import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import AgreementsModal from 'pages/Events/Views/Common/Modals/AgreementsModal'
import { classesEventStore } from 'state/classes/classesStore'

const Agreements: React.FC = () => {
  const [agreementsModal, setAgreementsModal] = useState<boolean>(false)
  const { classesData, agreements, setAgreements } = classesEventStore(
    store => ({
      classesData: store.classesData,
      agreements: store.agreements,
      setAgreements: store.setAgreements,
    }),
  )

  return (
    <>
      <div onClick={() => setAgreementsModal(true)}>
        <IconsTextNavigation
          iconName="Checks"
          heading="Agreements"
          isCompleted={agreements.length > 0 ? true : false}
        />
      </div>

      {agreementsModal && (
        <AgreementsModal
          modalOpen={agreementsModal}
          setModalOpen={setAgreementsModal}
          type="class"
          entityId={classesData?._id}
          selectedAgreementsIds={agreements}
          setSelectedAgreementsIds={setAgreements}
        />
      )}
    </>
  )
}

export default Agreements
